export const ENTITY = 'NETWORK';
